import { render } from "./soal-kompetensi_menjodohkan.vue?vue&type=template&id=562b510c&scoped=true"
import script from "./soal-kompetensi_menjodohkan.vue?vue&type=script&lang=js"
export * from "./soal-kompetensi_menjodohkan.vue?vue&type=script&lang=js"

import "./soal-kompetensi_menjodohkan.vue?vue&type=style&index=0&id=562b510c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562b510c"]])

export default __exports__